export const fixIframeUrls = (html) => {
  return html.replace(/<iframe[^>]*src=["']([^"':]+)["']/gi, (match, src) => {
    const fixedSrc = src.startsWith("http") ? src : `https://${src}`;
    return match.replace(src, fixedSrc);
  });
};

export const fixInvalidLinks = (html) => {
  return html.replace(/<a([^>]*href=["']([^"']+)["'][^>]*)>/gi, (match, attributes, href) => {
    const isInvalidLink = !href || href === "#" || href === "" || (href.startsWith("#") && href.length === 1) || (!href.startsWith("http") && !href.startsWith("mailto:") && !href.startsWith("tel:"));

    if (isInvalidLink) {
      const cleanAttributes = attributes.replace(/href=["'][^"']*["']/gi, "");
      return `<a${cleanAttributes} onclick="event.preventDefault(); return false;">`;
    }

    if (href.startsWith("http")) {
      return `<a${attributes} target="_blank" rel="noopener noreferrer">`;
    }

    return match;
  });
};

export const addSecurityAndBaseTags = (html) => {
  const securityTags = `
      <base target="_parent">
      <meta http-equiv="Content-Security-Policy" content="frame-ancestors 'self';">
    `;

  if (html.includes("<head>")) {
    return html.replace("<head>", `<head>${securityTags}`);
  } else if (html.includes("<html>")) {
    return html.replace("<html>", `<html><head>${securityTags}</head>`);
  } else {
    return `<head>${securityTags}</head>${html}`;
  }
};

export const addClickPrevention = (html) => {
  const preventionScript = `
      <script>
        document.addEventListener('DOMContentLoaded', function() {
          // Prevent invalid link navigation
          var links = document.querySelectorAll('a');
          links.forEach(function(link) {
            var href = link.getAttribute('href');
            if (!href || href === '#' || href === '' || (href.startsWith('#') && href.length === 1)) {
              link.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                return false;
              });
              link.style.cursor = 'default';
              link.style.textDecoration = 'none';
            }
          });
          
          // Prevent form submissions that might cause navigation issues
          var forms = document.querySelectorAll('form');
          forms.forEach(function(form) {
            if (!form.getAttribute('action') || form.getAttribute('action') === '#') {
              form.addEventListener('submit', function(e) {
                e.preventDefault();
                e.stopPropagation();
                return false;
              });
            }
          });
        });
      </script>
    `;

  return html.replace("</body>", `${preventionScript}</body>`);
};
